import type { WazuhAgentSummary } from '../../types';

const SEGMENTS: { key: keyof WazuhAgentSummary; label: string; color: string }[] = [
  { key: 'active', label: 'Active', color: '#26a698' },
  { key: 'disconnected', label: 'Disconnected', color: '#e11d48' },
  { key: 'pending', label: 'Pending', color: '#f59e0b' },
  { key: 'neverConnected', label: 'Never connected', color: '#94a3b8' },
];

export function AgentStatusRing({ summary }: { summary: WazuhAgentSummary }) {
  const total = summary.total || 1;
  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  let offsetAcc = 0;

  return (
    <div className="flex items-center gap-6">
      <svg width="140" height="140" viewBox="0 0 140 140" className="shrink-0 -rotate-90">
        <circle cx="70" cy="70" r={radius} fill="none" stroke="currentColor" strokeWidth="14" className="text-slate-100 dark:text-slate-800" />
        {SEGMENTS.map((seg) => {
          const value = summary[seg.key] as number;
          const fraction = value / total;
          const dash = fraction * circumference;
          const circle = (
            <circle
              key={seg.key}
              cx="70"
              cy="70"
              r={radius}
              fill="none"
              stroke={seg.color}
              strokeWidth="14"
              strokeDasharray={`${dash} ${circumference - dash}`}
              strokeDashoffset={-offsetAcc}
              strokeLinecap="butt"
            />
          );
          offsetAcc += dash;
          return circle;
        })}
        <text x="70" y="70" textAnchor="middle" dy="0.35em" className="fill-slate-900 text-2xl font-bold dark:fill-white" transform="rotate(90 70 70)">
          {summary.total}
        </text>
      </svg>

      <div className="space-y-2">
        {SEGMENTS.map((seg) => (
          <div key={seg.key} className="flex items-center gap-2 text-sm">
            <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: seg.color }} />
            <span className="text-slate-500 dark:text-slate-400">{seg.label}</span>
            <span className="font-semibold text-slate-800 dark:text-slate-200">{summary[seg.key] as number}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
